export const server = (process.env.NODE_ENV === "development" ? "http://localhost:3001" : window.location.origin);
export const client = (process.env.NODE_ENV === "development" ? "http://localhost:3000" : window.location.origin);

export const createNewRoom = "CREATE_NEW_ROOM";
export const roomCreated = "ROOM_CREATED";
export const closeRoom = "CLOSE_ROOM";
export const gameCompleted = "GAME_COMPLETED";

// Host reconnection and authorization
export const hostRejoinRoom = "HOST_REJOIN_ROOM";
export const hostRejoinSuccess = "HOST_REJOIN_SUCCESS";
export const hostRejoinFailed = "HOST_REJOIN_FAILED";
export const hostTokenInvalid = "HOST_TOKEN_INVALID";
export const hostGrantInvalid = "HOST_GRANT_INVALID";

export const userCountUpdate = "USER_COUNT_UPDATE";
export const playerListUpdate = "PLAYER_LIST_UPDATE";
export const playerJoined = "PLAYER_JOINED";

export const addToRoom = "ADD_TO_ROOM";
export const joinedToRoom = "JOINED_TO_ROOM";
export const nicknameIsTaken = "NICKNAME_IS_TAKEN";
export const roomNotFound = "ROOM_NOT_FOUND";
export const sessionTakenOver = "SESSION_TAKEN_OVER";
export const playerRoomSnapshot = "PLAYER_ROOM_SNAPSHOT";
export const joinRateLimited = "JOIN_RATE_LIMITED";

// Knockout mode events
export const playerEliminated = "PLAYER_ELIMINATED";
export const answerRejectedEliminated = "ANSWER_REJECTED_ELIMINATED";

export const newQuestion = "NEW_QUESTION";
export const answersOpen = "ANSWERS_OPEN";
export const closeQuestion = "CLOSE_QUESTION";
export const answersClose = "ANSWERS_CLOSE";
export const answerSelected = "ANSWER_SELECTED";
export const answerCountUpdate = "ANSWER_COUNT_UPDATE";
export const timerSync = "TIMER_SYNC";

export const answerStatsRequest = "ANSWER_STATS_REQUEST";
export const answerStatsResponse = "ANSWER_STATS_RESPONSE";

export const generalRankingRequest = "GENERAL_RANKING_REQUEST";
export const generalRankingResponse = "GENERAL_RANKING_RESPONSE";

export const quizStarting = "QUIZ_STARTING";

// Auto-advance (when time limit is enabled)
export const autoAdvanceScheduled = "AUTO_ADVANCE_SCHEDULED";
export const autoAdvanceCancelled = "AUTO_ADVANCE_CANCELLED";
